// Blog post helpers (sections/article-header.liquid, sections/article-story.liquid):
// copy-link button, photo mosaic viewer, and highlighting the current heading in "In this article".
(() => {
  if (window.klpdArticleStory) return;
  window.klpdArticleStory = true;

  // Copy link
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-copy-link]');
    if (!button) return;
    const done = () => {
      const message = button.parentElement.querySelector('.article-header__copied');
      if (!message) return;
      message.hidden = false;
      setTimeout(() => (message.hidden = true), 2000);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(button.dataset.copyLink).then(done, () => {});
  });

  // Photo viewer for the mosaic
  let viewer;
  let photos = [];
  let current = 0;

  const show = (index) => {
    current = (index + photos.length) % photos.length;
    const image = viewer.querySelector('img');
    image.src = photos[current].dataset.full;
    image.alt = photos[current].dataset.alt || '';
    viewer.querySelector('[data-count]').textContent = `${current + 1} / ${photos.length}`;
  };

  const getViewer = () => {
    if (viewer) return viewer;
    viewer = document.createElement('dialog');
    viewer.className = 'story-lightbox';
    viewer.setAttribute('aria-label', 'Photos');
    viewer.innerHTML =
      '<img alt=""><div class="story-lightbox__bar">' +
      '<button type="button" data-prev aria-label="Previous photo">&larr;</button>' +
      '<span data-count></span>' +
      '<button type="button" data-next aria-label="Next photo">&rarr;</button>' +
      '<button type="button" data-close aria-label="Close">&times;</button></div>';
    viewer.querySelector('[data-prev]').addEventListener('click', () => show(current - 1));
    viewer.querySelector('[data-next]').addEventListener('click', () => show(current + 1));
    viewer.querySelector('[data-close]').addEventListener('click', () => viewer.close());
    viewer.addEventListener('click', (event) => {
      if (event.target === viewer) viewer.close();
    });
    viewer.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });
    document.body.appendChild(viewer);
    return viewer;
  };

  document.addEventListener('click', (event) => {
    const item = event.target.closest('.story-gallery__item');
    if (!item) return;
    photos = [...item.closest('[data-story-gallery]').querySelectorAll('.story-gallery__item')];
    getViewer().showModal();
    show(photos.indexOf(item));
  });

  // Contents: mark the heading the reader has scrolled to
  const initToc = () => {
    document.querySelectorAll('[data-story-toc]').forEach((toc) => {
      const links = [...toc.querySelectorAll('a')];
      const headings = links.map((link) => document.querySelector(link.getAttribute('href'))).filter(Boolean);
      if (!headings.length || !('IntersectionObserver' in window)) return;
      const mark = (heading) =>
        links.forEach((link) => link.setAttribute('aria-current', link.getAttribute('href') === `#${heading.id}` ? 'true' : 'false'));
      mark(headings[0]);
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries.filter((entry) => entry.isIntersecting);
          if (visible.length) mark(visible[0].target);
        },
        { rootMargin: '0px 0px -70% 0px' }
      );
      headings.forEach((heading) => observer.observe(heading));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initToc);
  else initToc();
})();
